<template>


</template>

<script>
	export default {
		name: 'ErrorStore',
		props: {
			count: {
				type: Number,
				default: 0
			},
			hasRead: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			countComputed() {
				return this.hasRead ? 0 : this.count
			}
		},
		data() {
			return {
				clientTipsModal: false,
				value4:false,
			}
		},
		methods: {
			openErrorLoggerPage() {
				this.value4 = true;
				this.$router.push({
					name: 'informcenter'
				})
			}
		}
	}
</script>

<style lang="less">
	.error-store {
		margin-right: 12px;

		.ivu-badge-dot {
			top: 20px;
		}

		.ivu-btn.ivu-btn-text {
			padding: 5px 1px 6px;
		}
	}
	.pStyle{
		
	}
</style>
